import { Space, theme } from 'antd';
import { Controller } from 'react-hook-form';
import { EditUserFormValues } from '../../../../../../../../types/userform';
import CustomField from '../../../../../../../components/CustomField';

import { usePaginatedUserFieldDefinitionListOnlyStatusParam } from '../../../../../../../hooks/useUserFieldDefinitionList';
import { USER_FORM_FIELDS_KEY } from '../../../../../../../model/types';
import { getValidationRules } from '../../../../../../../utils/forms/formHelper.validators';

export const MIN_FIELD_ARRAY_LENGTH = 2; // [ts.requester, ts.assignee]

const generateReactHookFormFriendlyFieldName = (fieldKey: string): any =>
    `${USER_FORM_FIELDS_KEY}.${fieldKey.replace(new RegExp('\\.', 'gi'), '$')}`;

const CustomUserFieldsContainer = ({ isActive }: { isActive: boolean }) => {
    const {
        token: { marginSM }
    } = theme.useToken();
    const { data: fields } = usePaginatedUserFieldDefinitionListOnlyStatusParam(true);

    return (
        <Space direction="vertical" className="full-width" size="small" style={{ marginBottom: marginSM }}>
            {fields?.list?.content?.map((fieldDefinition) => {
                //HACK: not display user external id field => GRISPI-2055
                if (fieldDefinition.key !== 'us.external_id')
                    return (
                        <Controller<EditUserFormValues>
                            key={fieldDefinition.key}
                            name={generateReactHookFormFriendlyFieldName(fieldDefinition.key)}
                            render={({ field: { value, onChange }, fieldState: { error } }) => {
                                return (
                                    <CustomField
                                        containerProps={{ errorMessage: error?.message }}
                                        fieldDefinition={fields.listMap[fieldDefinition.key]}
                                        value={value}
                                        onChange={onChange}
                                        disabled={!isActive}
                                    />
                                );
                            }}
                            rules={{
                                validate: getValidationRules({ fieldDefinition })
                            }}
                        />
                    );
            })}
        </Space>
    );
};

export default CustomUserFieldsContainer;
